import { apiOrchestrator, apiStrapi } from 'services/apiService';
import { logger } from 'utils/logger';

export const debugApiRequests = () => {
  logger.debug('=== DEBUG API REQUESTS ===');

  // Check API headers
  const orchestratorHeaders = apiOrchestrator.getInstance().defaults.headers.common;
  const strapiHeaders = apiStrapi.getInstance().defaults.headers.common;

  logger.debug('Orchestrator Headers:', { data: orchestratorHeaders });
  logger.debug('Strapi Headers:', { data: strapiHeaders });

  // Check localStorage
  const localStorageData = {
    AUTH_TOKEN: localStorage.getItem('AUTH_TOKEN'),
    user_id: localStorage.getItem('user_id'),
    'x-organization-uuid': localStorage.getItem('x-organization-uuid'),
    'x-cognito-userpool': localStorage.getItem('x-cognito-userpool'),
  };

  logger.debug('LocalStorage Data:', { data: localStorageData });

  // Check if instances are configured
  logger.debug('Orchestrator Base URL:', apiOrchestrator.getInstance().defaults.baseURL);
  logger.debug('Strapi Base URL:', apiStrapi.getInstance().defaults.baseURL);

  return {
    orchestratorHeaders,
    strapiHeaders,
    localStorageData,
  };
};

export const testApiConnection = async () => {
  try {
    logger.debug('=== TESTING API CONNECTION ===');

    // Test if the token is configured
    const token = localStorage.getItem('AUTH_TOKEN');
    if (!token) {
      logger.error('No token found in localStorage');
      return false;
    }

    // Test simple request
    const response = await apiOrchestrator.get('/auth/me');
    logger.debug('Test response:', { data: response });
    return true;
  } catch (error) {
    logger.error('API connection test failed:', error);
    return false;
  }
};
